import { withInstall } from '@antdv/utils';
import ASegmented from './src/Segmented';

export const Segmented = withInstall(ASegmented);

export default Segmented;

export * from './src/interface';
export * from './src/props';
